import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Grid from '@material-ui/core/Grid'
import _ from 'lodash'
import { reduxForm} from 'redux-form'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';
import Number from '../../../../../uis/form/number';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
        padding: '1rem'
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    }
})

const validate = values => {
    const errors = {}
    
    if (!values.keyword) {
        errors.keyword = '必填'
    }
    if (values.keyword && /[\u4e00-\u9fa5]/.test(values.keyword)) {
        errors.keyword = '暂不支持中文关键词'
    }
    if (!values.width) {
        errors.width = '必填'
    }
    if (!values.height) {
        errors.height = '必填'
    }
    if (!values.count) {
        errors.count = '必填'
    }
    if (values.count && values.count > 10) {
        errors.count = '一次最多只能下载10张'
    }
    return errors
}

class AddDialog extends React.Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Paper elevation={1} style={{padding: '1rem'}}>
                        <Typography component="p">
                            1. 关键词只支持英文，可以先把中文翻译好,再输入关键词
                        </Typography>
                        <Typography component="p">
                            2. 批量下载一次最多下载10张
                        </Typography>
                    </Paper>
                    <Text name="keyword" label="关键词" placeholder="关键词只支持英文" className={classes.textField} required={true}/>
                    
                    <Number name="width" label="宽度" placeholder="请输入宽度" className={classes.textField} required={true}/>
                    
                    <Number name="height" label="高度" placeholder="请输入高度" className={classes.textField} required={true}/>
                    
                    <Number name="count" label="数量" placeholder="请输入数量" className={classes.textField} required={true}/>
                    
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    
                    <Text name="url" label="链接" placeholder="请输入链接" className={classes.textField} required={false} data={[]}/>
                    
                    <Number name="width" label="宽度" placeholder="请输入宽度" className={classes.textField} required={false} data={[]}/>
                    
                    <Number name="height" label="高度" placeholder="请输入高度" className={classes.textField} required={false} data={[]}/>
                    
                    <Text name="keyword" label="关键词" placeholder="请输入关键词" className={classes.textField} required={false} data={[]}/>
                    
                    <Text name="labels" label="标签" placeholder="请输入标签" className={classes.textField} required={false} data={[]}/>
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => ({
      initialValues: {
          width: 1920,
          height: 600,
          count: 1
      }
    }),
  )(reduxForm({
    form: 'photoGalleryAddForm',
    validate
})(AddDialog))

const UpdateFormDialog = connect(
    state => ({
      initialValues: state.photoGallery.detail
    }),
  )(reduxForm({
    form: 'photoGalleryUpdateForm'
})(UpdateDialog))

class Photogallery extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target.value})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['图片集_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>批量下载图片</Button>}
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Paper className={classes.root} id="photo-gallery">
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Grid container spacing={8}>
                        {list.map(row => {
                            const height = document.querySelector('#photo-gallery') ? ((document.querySelector('#photo-gallery').offsetWidth - 56) / 4) / (1920 / 600) : 'auto';
                            return (
                                <Grid item  xs={3}>
                                    
                                    <Card>
                                        <a href={row.url} target="_blank">
                                            <img src={row.url} width="100%" height={height} alt={row.keyword} />
                                        </a>
                                        <CardContent>
                                            <Typography gutterBottom variant="headline" component="h2">
                                                {row.keyword}
                                            </Typography>
                                            <Typography component="p">
                                                {row.width} x {row.height}
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={() => window.location.href = row.url.replace('x-oss-process=style/small', 'response-content-type=application%2Foctet-stream')}>
                                                下载图片
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            )
                        })}
                        <Grid item  xs={12}>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </Grid>
                        
                    </Grid>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.photoGallery,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Photogallery))


// WEBPACK FOOTER //
// ./src/pages/home/routes/photo_gallery/components/list.js